<template>
  <form data-vv-scope="questions">
    <div
      class="row"
      v-if="securityQuestions && Object.values(securityQuestions).length"
    >
      <div class="col-12">
        <div
          class="mt-3"
          v-for="(question, index) in Object.values(securityQuestions)"
          :key="index"
        >
          <b>{{ question.text }}</b>
          <vs-select
            autocomplete
            class="w-100 con-select autocompletex"
            label="Seleccione"
            name="valor"
            v-model="question.valor"
            :danger="errors.has('questions.valor')"
            :danger-text="errors.first('questions.valor')"
            v-validate="'required'"
          >
            <vs-select-item
              :value="option.id"
              :text="option.texto"
              v-for="(option, index) in question.opciones"
              :key="index"
            />
          </vs-select>
        </div>
      </div>
    </div>
    <div class="text-right mt-4">
      <b-button :disabled="loading" variant="primary" @click="verifySecurityQuestions">
        Verificar
        <b-spinner small v-if="loading" variant="primary"/>
      </b-button>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex';

import { cuVerificationInfo } from '@/febos/servicios/api/usuarios.api';
import { cuVerificationInfoExternal } from '@/febos/servicios/api/v2.aprobaciones.api';

export default {
  name: 'SecurityQuestions',
  props: ['securityQuestions', 'getCertificate', 'loading', 'cuUserData', 'isExternal'],
  computed: {
    ...mapGetters('Empresas', [
      'company'
    ]),
    token() {
      const { token } = this.$route.params;
      return token;
    },
  },
  methods: {
    async verifySecurityQuestions() {
      this.$emit('loading', true);
      const isValid = await this.$validator.validateAll('questions');
      if (!isValid) {
        this.$emit('loading', false);
        return;
      }
      try {
        const parsed = Object.keys(this.securityQuestions)
          .reduce((index, option) => ({
            ...index,
            [option]: {
              id: this.securityQuestions[option].id,
              valor: this.securityQuestions[option].valor
            }
          }), {});
        const { idProceso } = this.$route.query;
        if (!this.isExternal) {
          await cuVerificationInfo({
            params: {
              tipo: this.isExternal ? 'esign7' : this.company.firmaAvanzada,
              accion: 'verificar_challenge',
              debug: ''
            },
            body: {
              idProceso,
              rut: this.cuUserData.iut,
              preguntas: parsed
            }
          });
        } else {
          await cuVerificationInfoExternal({
            params: {
              tipo: this.isExternal ? 'esign7' : this.company.firmaAvanzada,
              accion: 'verificar_challenge',
              debug: ''
            },
            headers: {
              Authorization: this.token
            },
            body: {
              idProceso,
              rut: this.cuUserData.iut,
              preguntas: parsed
            }
          });
        }
        this.$emit('loading', false);
        this.$emit('closeModal');
      } catch {
        this.$emit('loading', false);
      }
    },
  }
};
</script>
